import type { Routes } from '@angular/router';
import { OnyxFormMode } from '@onyx/angular';
import { permissionGuard } from '../../../auth/common/guards/permission.guard';
import type { FormResolverData } from '../../../common/interfaces/common/form-resolver-data';
import type { BaseForm } from './common/helpers/base-form.helper';
import { addBaseResolver } from './common/resolvers/add-base.resolver';
import { baseCardResolver } from './common/resolvers/base-card.resolver';
import { editBaseResolver } from './common/resolvers/edit-base.resolver';

export type BaseFormResolverData = FormResolverData<BaseForm>;

export const BASES_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./bases-list/bases-list.component').then(
        (m) => m.BasesListComponent,
      ),
    canActivate: [permissionGuard('bases.get')],
  },
  {
    path: 'add',
    loadComponent: () =>
      import('./base-form/base-form.component').then(
        (m) => m.BaseFormComponent,
      ),
    canActivate: [permissionGuard('bases.add')],
    data: { mode: OnyxFormMode.ADD },
    resolve: { data: addBaseResolver },
  },
  {
    path: ':uuid',
    children: [],
    canActivate: [permissionGuard('bases.get')],
    resolve: { _: baseCardResolver },
  },
  {
    path: ':uuid/edit',
    loadComponent: () =>
      import('./base-form/base-form.component').then(
        (m) => m.BaseFormComponent,
      ),
    canActivate: [permissionGuard('bases.edit')],
    data: { mode: OnyxFormMode.EDIT },
    resolve: { data: editBaseResolver },
  },
] as const;
